import { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import { LocationContext } from '../../../Providers/Geolocation';

import { ViewAllButton, Collection, Item, Store } from './styles';

const OptimumStoresCollection = ({ stores, component = '' }) => {
  if (!stores) return null;

  const intl = useIntl();
  const location = useContext(LocationContext);

  const [fullList, setFullList] = useState(false);

  return (
    <>
      <Collection
        aria-live={component === 'pc-optimum-store-accordion' ? 'polite' : null}
      >
        {stores
          .filter(({ noAvailability }) => !noAvailability?.includes(location))
          .map(({ id, logoDam }, index) => {
            return (
              <Item
                key={id}
                className={
                  // eslint-disable-next-line no-nested-ternary
                  component === 'pc-optimum-store-accordion'
                    ? fullList || index < 6
                      ? 'show'
                      : 'hide'
                    : null
                }
              >
                <Store src={logoDam} alt={logoDam.altText || ''} role="img" />
              </Item>
            );
          })}
      </Collection>
      {component === 'pc-optimum-store-accordion' ? (
        <ViewAllButton
          full={fullList}
          onClick={() => setFullList(true)}
          aria-label={`${intl.formatMessage({
            id: 'viewAllAria',
          })}`}
        >
          <span>{intl.formatMessage({ id: 'viewAll' })}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="7 6 9 10"
          >
            <path
              fill="currentColor"
              fillRule="evenodd"
              d="M11.417 13.887l-4.47-4.123.507-.55a.499.499 0 0 1 .704-.029l3.259 3.006 3.258-3.006a.499.499 0 0 1 .704.03l.508.549-4.47 4.123z"
            />
          </svg>
        </ViewAllButton>
      ) : null}
    </>
  );
};

OptimumStoresCollection.propTypes = {
  stores: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  component: PropTypes.string,
};

export default OptimumStoresCollection;
